import type { AppDefinition } from '../../types/apps';

export const RulesAppV2Definition: AppDefinition = {
  appId: 'rules',
  name: 'Rule',
  version: '2.0.0',
  description: 'Create and edit AI behavior rules',
  icon: {
    type: 'phosphor',
    phosphorIcon: 'Scroll',
    phosphorWeight: 'duotone',
  },
  entityIcons: {
    Rule: {
      type: 'phosphor',
      phosphorIcon: 'Scroll',
      phosphorWeight: 'duotone',
      color: '#2563eb',
    },
  },
  entityTypes: ['Rule'],
  component: 'rules',
  requiresProps: false,
  requiresEntity: true,
  actions: {},
};
